exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.private_form[data-v-3a890e4d] {\n  font-size: 24px;\n  color: #f00;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 10rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/Form/src/components/Main/Form/FeedbackDetail.vue","/./src/components/Main/Form/FeedbackDetail.vue"],"names":[],"mappings":";AA+BA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;CC9BD","file":"FeedbackDetail.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../styles/variables.styl'\n.private_form {\n  font-size: 24px;\n  color: red;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 10rem;\n}\n",".private_form {\n  font-size: 24px;\n  color: #f00;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 10rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-3a890e4d&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Form/FeedbackDetail.vue
// module id = 620
// module chunks = 0